// extracted by css-extract-rspack-plugin
var _1 = "message-block-WizoYO";
var _2 = "message-content-UjLh39";
var _3 = "message-estimate-L66SPs";
var _4 = "message-header-z89Ehr";
var _5 = "message-label-uXi7mP";
var _6 = "message-title-rDAMyf";
var _7 = "message-block-WizoYO";
var _8 = "message-content-UjLh39";
var _9 = "message-estimate-L66SPs";
var _a = "message-header-z89Ehr";
var _b = "message-label-uXi7mP";
var _c = "message-title-rDAMyf";
var _d = "request-estimate-AgCGdK";
var _e = "request-estimate-AgCGdK";
export { _1 as "message-block", _2 as "message-content", _3 as "message-estimate", _4 as "message-header", _5 as "message-label", _6 as "message-title", _7 as "messageBlock", _8 as "messageContent", _9 as "messageEstimate", _a as "messageHeader", _b as "messageLabel", _c as "messageTitle", _d as "request-estimate", _e as "requestEstimate" }
